import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PeopleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"people_outline"}/>
}
